<template>
  <div id="edit-asset">
    <div class="ContentContainer ContentContainer--WithButton">
      <BackButton />
      <h3 class="heading-lined">
        {{ $t("edit_asset_page.add") }}
        {{ coin.name }}
      </h3>

      <form class="clearfix mt-5" @submit.prevent="updateAssetAndRedirect">
        <label>{{
          $t("edit_asset_page.how_much", {
            assetName: coin.name,
            assetSymbol: coin.symbol,
          })
        }}</label>
        <input
          type="number"
          class="form-control form-control-lg"
          step="0.000000001"
          v-model="holdings"
          ref="input"
        />

        <button
          v-if="!coin.deleted"
          type="submit"
          class="btn btn-primary btn-lg mt-3 mr-2"
        >
          <i class="fa fa-check mr-1 mr-sm-2"></i
          >{{ $t("edit_asset_page.save") }}
        </button>

        <button
          class="btn btn-secondary btn-lg mt-3"
          v-if="holdingsInPortfolio || coin.deleted"
          @click.prevent="removeAssetAndRedirect"
        >
          <i class="fa fa-trash mr-0 mr-sm-2"></i>
          <span class="d-none d-md-inline hidden-xs-down">{{
            $t("edit_asset_page.delete")
          }}</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BackButton from "./../BackButton";

export default {
  name: "EditAsset",
  components: {
    BackButton,
  },
  data() {
    return {
      holdings: 0,
    };
  },
  computed: {
    coin() {
      let coin = this.coinByFindParams({
        currencyId: this.$route.params.symbol,
        symbol: this.$route.params.symbol,
      });
      if (!coin) {
        coin = {
          name: "Deleted Coin",
          symbol: this.$route.params.symbol,
          deleted: true,
        };
      }
      return coin;
    },
    asset() {
      const searchParams = {
        exchId: 0,
        currencyId: this.coin.id || this.$route.params.symbol,
        currency: this.coin.symbol || this.$route.params.symbol,
      };
      let asset = this.assetByFindParams(searchParams);
      return asset || searchParams;
    },
    holdingsInPortfolio() {
      return this.asset.holdings || 0;
    },
    ...mapGetters({
      coinByFindParams: "coinmarketcap/coinByFindParams",
      assetByFindParams: "portfolio/assetByFindParams",
    }),
  },
  methods: {
    updateAssetAndRedirect() {
      const { asset } = this;
      // chrome bug transforms number to string is input arrows are use
      const holdings = Number(this.holdings);
      const assetData = {
        exchId: asset.exchId,
        currencyId: asset.currencyId,
        currency: asset.currency,
        holdings,
      };
      this.updateAsset(assetData);
      this.$router.push("/");
    },
    removeAssetAndRedirect() {
      this.removeAsset(this.asset);
      this.$router.push("/");
    },
    ...mapActions({
      updateAsset: "portfolio/updateAsset",
      removeAsset: "portfolio/removeAsset",
    }),
  },
  mounted() {
    this.holdings = this.holdingsInPortfolio;
    this.$refs.input.focus();
    this.$refs.input.select();
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-right: 120px;
}

label {
  font-weight: 700;
  font-size: 22px;
}

input {
  padding: 20px 25px;
  border-radius: 8px;
  font-size: 22px;
}
</style>
